import { render, staticRenderFns } from "./TeachersTable.vue?vue&type=template&id=2d1b41bc&scoped=true&"
import script from "./TeachersTable.vue?vue&type=script&lang=ts&"
export * from "./TeachersTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1b41bc",
  null
  
)

export default component.exports